import React from "react";
import { Table, Tooltip, Button, Form, Input } from "antd";

import { FORMAT_5DECIMALS } from "../../../../common/types/regularExpresionType";
import auth from "../../../../common/utility/auth";
import { LOGISTICA_PRODUCTOS_CON_LOTE } from '../../../../common/types/parametroType'

import "../styles.css";

export default function DetalleLogisticaTipoImporteGanancia(props) {
  const mostrarLoteProducto = auth.user().parametros.filter(m => m.abreviatura === LOGISTICA_PRODUCTOS_CON_LOTE)[0].valor === "1" ? true : false;

  return (
    <Table
      size="small"
      style={{ overflowX: "auto" }}
      rowKey={(m) => m.id}
      dataSource={props.source}
      className={"table-detalle-logistica-tipo-importe-ganancia"}
      pagination={{
        pageSize: 10,
        showTotal: (total) => `${total} Registro(s) encontrado(s).`,
      }}
      columns={[
        {
          key: "options",
          align: "center",
          width: "70px",
          render: (value, row) => (
            <div className="custom-options">
              <Tooltip placement="top" title={"Editar"}>
                <Button
                  type="primary"
                  icon="edit"
                  size={"small"}
                  style={{ display: row.edit ? "none" : "" }}
                  onClick={() => {
                    props.onEdit(row, props.form); 
                  }}
                />
              </Tooltip>
              <Tooltip placement="top" title={"Guardar"}>
                <Button
                  type="primary"
                  icon="save"
                  size={"small"}
                  style={{ display: row.edit ? "" : "none" }}
                  onClick={() => props.onSave(row)}
                />
              </Tooltip>
              <Tooltip placement="top" title={"Cancelar"}>
                <Button
                  icon="close"
                  size={"small"}
                  style={{ display: row.edit ? "" : "none" }}
                  onClick={() => props.onEdit(0)}
                />
              </Tooltip>
            </div>
          ),
        },
        {
          title: "Código",
          dataIndex: "codigoReferenciaProducto",
          key: "codigoReferenciaProducto",
        },
        {
          title: "Nombre",
          dataIndex: "nombreProducto",
          key: "nombreProducto",
        },
        (mostrarLoteProducto?    {
          title: "Lote",
          dataIndex: "lote",
          key: "lote",
        }:
        {
          title: "Lote",
          dataIndex: "lote",
          key: "lote",
          className: 'hide',
        }
        ),
    
        {
          title: "Tipo Producto",
          dataIndex: "nombreTipoProducto",
          key: "nombreTipoProducto",
        },

        {
          title: "",
          dataIndex: "idTipoProducto",
          className: "hide",
          key: "idTipoProducto",
          render: (value, row) => {
            return (
              <div>
                {props.onGetFieldDecorator(
                  `arrIdTipoProducto[${"IdTipoProducto" + row.id}]`,
                  { initialValue: value }
                )(<Input />)}
              </div>
            );
          },
        },
        {
          title: 'Precio Promedio Soles',
          dataIndex: 'precioPromedioSolesStr',
          key: 'precioPromedioSolesStr',
          className:'column-promedio',
          align: 'right'
      },
        {
          title: 'Costo Promedio Soles',
          dataIndex: 'valorPromedioSolesStr',
          key: 'valorPromedioSolesStr',
          className:'column-promedio',
          align: 'right'
      },
      {
        title: 'Precio Promedio Dólares',
        dataIndex: 'precioPromedioDolaresStr',
        key: 'precioPromedioDolaresStr',
        className:'column-promedio',
        align: 'right'
    },
      {
          title: 'Costo Promedio Dólares',
          dataIndex: 'valorPromedioDolaresStr',
          key: 'valorPromedioDolaresStr',
          className:'column-promedio',
          align: 'right'
      },
  
        {
            title: "Porcentaje Margen Comercial",
            dataIndex: "porcentajeMargenComercial",
            key: "porcentajeMargenComercial",
            align: "right",
            render: (value, row) => {
              if (row.edit)
                return (
                  <Form.Item>
                    {props.onGetFieldDecorator(
                      `arrPorcentajeMargenComercial[${"LP" + row.id}]`,
                      {
                        initialValue: parseFloat(value).toFixed(5),
                        rules: [
                          {
                            required: true,
                            pattern: new RegExp(FORMAT_5DECIMALS),
                            message: "Formato (0.00)",
                          },
                        ],
                      }
                    )(
                      <Input
                        placeholder="Porcentaje Margen Comercial"
                        autoComplete="off"
                        className="text-right"
                        onBlur={(e) =>
                          props.onCompleteDecimals("LP" + row.id, e.target.value)
                        }
                        onKeyUp={(e) => props.onSave(row.id, e)}
                      />
                    )}
                  </Form.Item>
                );
  
              return <span>{value.toFixed(5)}</span>;
            },
          },
        // {
        //   title: "Importe de Ganancia Soles",
        //   dataIndex: "importeGananciaSoles",
        //   key: "importeGananciaSoles",
        //   align: "right"
        // },
        // {
        //     title: "Importe de Ganancia Dólares",
        //     dataIndex: "importeGananciaDolares",
        //     key: "importeGananciaDolares",
        //     align: "right"
        //   },
        {
          title: "Valor Unitario Soles",
          dataIndex: "valorUnitarioSolesStr",
          key: "valorUnitarioSolesStr",
          className: 'column-total',
          align: "right",
        },
        {
          title: "Precio Unitario Soles",
          dataIndex: "precioUnitarioSolesStr",
          key: "precioUnitarioSolesStr",
          className: 'column-total',
          align: "right",
        },
        {
          title: "Valor Unitario Dólares",
          dataIndex: "valorUnitarioDolaresStr",
          key: "valorUnitarioDolaresStr",
          className: 'column-total',
          align: "right",
        },
        {
          title: "Precio Unitario Dólares",
          dataIndex: "precioUnitarioDolaresStr",
          key: "precioUnitarioDolaresStr",
          className: 'column-total',
          align: "right",
        }
      ]}
    />
  );
}
